// extracted by mini-css-extract-plugin
export default {"wrapperMobile":"rYLr_A6LQfvzan2RHrWM","bulletDescription":"gPIdpIPq7ZFYEgLO7jMr","pastDate":"Tn_Nn0EPCPjeMFR4btaL"};